
const vendaGridConfig = {
  idField: "idVenda",
  columns: [
    { header: "Cod.", field: "IDVENDA" },
    { header: "Data", field: "DATAVENDA" },
    { header: "Cliente", field: "NOME" },
    { header: "Valor", field: "valor_total_com_desconto" },
    { header: "Status", field: "CANCELADA", 
      formatter: (value) => (value ? "Cancelada" : "Confirmada")
    },
    { header: "Pago", field: "PAGO", 
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default vendaGridConfig;